import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function useUnreadCount() {
  const [counts, setCounts] = useState({ total: 0, chat: 0 });
  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const { data } = await api.get("/notifications?limit=50");
        if (!alive) return;
        const chat = data.notifications.filter((n) => !n.read && n.type === "message").length;
        setCounts({ total: data.unread, chat });
      } catch {}
    };
    tick();
    const t = setInterval(tick, 5000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return counts;
}
